import {useEffect} from 'react';

const useOutsideAlerter = (ref: any, setterFunction: any, hover: boolean = false) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setterFunction(false);
      }
    };
    const handleMoveOutside = (event: any) => {
      if (ref.current && ref.current.contains(event.target)) {
        return;
      } else {
        setterFunction(false);
      }
    };
    document.addEventListener('mouseup', handleClickOutside);
    hover && document.addEventListener('mouseover', handleMoveOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      hover && document.addEventListener('mouseover', handleMoveOutside);
    };
  }, [ref]);
};

export default useOutsideAlerter;
